import { Button, Card, Col, message, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DetailItem from "../../components/DetailItem";
import TitleSection from "../../components/TitleSection";
import { httpRequest } from "../../helpers/api";
import { getErrorMessage } from "../../helpers/errorHandler";
import { BaseResponseProps } from "../../types/config.type";
import TransferEmployeeStatus from "../../components/TransferEmployeeStatus";
import useBreadcrumbs from "../../hooks/useBreadcrumbs";
import { TransferMemberTeamProperties } from "../../types/transferMemberTeam.type";
import TextOrNotSet from "../../components/TextOrNotSet";
import { ETransferEmployeeStatus } from "../../types/transferEmployee.type";
import MemberTransferHistory from "./Components/MemberTransferHistory";
import { formatYearToTime } from "../../helpers/format";
import AddMember from "../group/CreateComponents/AddMember";
import { ListItem } from "../group/CreateComponents/GroupInformation";
import { memberFormatted } from "../../helpers/member";

interface Params {
	transferMemberId: string;
}

const TransferMemberDetail: React.FC = () => {
	const { setBreadcrumb } = useBreadcrumbs();
	const params = useParams<Params>();
	const [showDetail, setShowDetail] = useState(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [transferMember, setTransferMember] = useState<TransferMemberTeamProperties>();
	const [selectedMember, setSelectedMember] = useState<ListItem | undefined>();

	const fetchData = async () => {
		setIsLoading(true);
		try {
			let { data } = await httpRequest.get<BaseResponseProps<TransferMemberTeamProperties>>(
				"transfer-member-teams/" + params.transferMemberId
			);
			let bc = [
				{
					label: data.payload.user?.nickName?.toUpperCase(),
					origin: params.transferMemberId,
				},
			];
			setBreadcrumb(bc);
			setTransferMember(data.payload);
			setIsLoading(false);
		} catch (error) {
			message.error(getErrorMessage(error));
		}
	};

	useEffect(() => {
		if (params.transferMemberId) {
			fetchData();
		}

		// eslint-disable-next-line
	}, [params.transferMemberId]);

	console.log(transferMember);
	return (
		<React.Fragment>
			<TitleSection
				title="Detail Transfer Team Member"
				icon="back"
			/>
			<Spin spinning={isLoading}>
				<Card
					size="small"
					bordered={false}
				>
					<Row
						gutter={[24, 0]}
						className="detail-bordered"
					>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="User ID">
								<TextOrNotSet value={transferMember?.originGroupMember?.employee?.employeeCode} />
							</DetailItem>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="Agent Name">
								<TextOrNotSet value={transferMember?.user?.nickName?.toUpperCase()} />
							</DetailItem>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="From Team">
								<TextOrNotSet value={transferMember?.originGroup?.groupName} />
							</DetailItem>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="To Team">
								<TextOrNotSet value={transferMember?.toGroup?.groupName} />
							</DetailItem>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="From Fee">
								<Button
									type="primary"
									onClick={() => {
										setShowDetail(true);
										const record = transferMember?.originGroupMember;
										let formatted = memberFormatted(record!);

										setSelectedMember(formatted);
									}}
								>
									See Detail Fees
								</Button>
							</DetailItem>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="To Fee">
								<Button
									type="primary"
									onClick={() => {
										setShowDetail(true);
										const record = transferMember?.toGroupMember;
										let formatted = memberFormatted(record!);

										setSelectedMember(formatted);
									}}
								>
									See Detail Fees
								</Button>
							</DetailItem>
						</Col>

						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="Status Transfer">
								<TransferEmployeeStatus value={transferMember?.status as ETransferEmployeeStatus} />
							</DetailItem>
						</Col>
						<Col
							xs={{ span: 24 }}
							md={{ span: 12 }}
						>
							<DetailItem label="Transferred At">
								<TextOrNotSet value={formatYearToTime(transferMember?.createdAt)} />
							</DetailItem>
						</Col>
					</Row>

					<MemberTransferHistory
						userId={transferMember?.userId}
						type="table"
					/>

					<AddMember
						open={showDetail}
						onClose={() => {
							setShowDetail(false);
							setSelectedMember(undefined);
						}}
						selectedMember={selectedMember}
						isDetail
					/>
				</Card>
			</Spin>
		</React.Fragment>
	);
};
export default TransferMemberDetail;
